function getFocusableElements(container) {
  if(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  return []
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'link');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.input.addEventListener('change', this.onChangeInput.bind(this));
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.checkAndDisableMinusButton();

    const maxAttr = this.input.getAttribute('max');
    this.max = maxAttr != null ? Number(maxAttr) : null;

    this.container = this.closest('.js-quantity-input-wrapper');
    this.maxQuantityError = this.container?.querySelector('.js-max-quantity-error');
  }

  onButtonClick(event) {
    event.preventDefault();
    const isPlus = event.target.name === 'plus';

    // If clicking "+" and value is already at or above max, show the error and stop increment
    if (isPlus && this.max != null && Number(this.input.value) >= this.max && this.maxQuantityError) {
      this.showMaxError();
      return;
    }

    const previousValue = this.input.value;
    isPlus ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    // Check if we can hide the error after the value changes
    this.checkHideMaxError();
  }

  onChangeInput() {
    this.checkAndDisableMinusButton(true);

    if (this.input.value < 1) {
      this.toggleAddButton();
    } else {
      this.toggleAddButton(false);
    }

    const value = Number(this.input.value);

    // If the value is greater than max, show the error
    if (this.max != null && value > this.max) {
      this.showMaxError();
    } else {
      this.checkHideMaxError();
    }
  }

  showMaxError() {
    if (!this.maxQuantityError) return;
    this.maxQuantityError.classList.remove('hidden');
    this.maxQuantityError.setAttribute('role', 'alert');
    this.maxQuantityError.setAttribute('aria-live', 'polite');
  }

  checkHideMaxError() {
    if (!this.maxQuantityError) return;
    const value = Number(this.input.value);
    if (this.max == null || value <= this.max) {
      this.maxQuantityError.classList.add('hidden');
    }
  }

  toggleAddButton(disable = true) {
    const productForm = this.input.form;
    const addButtonText = productForm?.querySelector('[name="add"] > span')?.innerText;
    if (!productForm || addButtonText === 'SOLD OUT ONLINE' || addButtonText === 'UNAVAILABLE') return;

    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
    } else {
      addButton.removeAttribute('disabled');
    }
  }

  checkAndDisableMinusButton(onChange = false) {
    if (this.classList.contains('js-class-fee-item')) return;
    
    const minusButton = this.querySelector('button[name="minus"]');
    if (!minusButton) return;

    if (this.input.value === this.input.min) {
      if (onChange) {
        this.input.focus();
      }
      minusButton.disabled = true;
    } else if (minusButton.disabled) {
      minusButton.disabled = false;
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelector(".menu-drawer-overlay").addEventListener('click', this.onCloseButtonClick.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    document.body.dispatchEvent(new CustomEvent('modalOpened'));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    if (this.classList.contains('autoplay')) {
      if (this.classList.contains('youtube')) {
        document.querySelector('.js-youtube').src += "&autoplay=1";
      } else {
        document.querySelector('.js-vimeo').src += "?autoplay=1";
      }
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    // some existing tech debt here. Previously scroll was bound to update()
    // however resetPages/initPages do some calculation logic that's needed for consistent scroll behavior.
    this.slider.addEventListener('scroll', this.resetPages.bind(this));

    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  isVerticalDesktopThumbRail() {
    return Boolean(this.slider?.classList.contains('slider--vertical-desktop') && window.matchMedia('(min-width: 750px)').matches);
  }

  initPages() {
    if (this.isVerticalDesktopThumbRail()) return;
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (this.isVerticalDesktopThumbRail()) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

function getMediaIdFromTarget(target) {
  if (!target) return null;
  const parts = String(target).split('-');
  return parts[parts.length - 1];
}

function revealVariantThumbnailRail(thumbRoot) {
  if (!thumbRoot || !thumbRoot.classList.contains('thumbnail-rails--awaiting-sync')) return;
  if (thumbRoot.classList.contains('is-thumbnail-rail-ready')) return;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      thumbRoot.classList.add('is-thumbnail-rail-ready');
      thumbRoot.setAttribute('aria-busy', 'false');
    });
  });
}

function syncVariantThumbnailRail() {
  const thumbRoot = document.querySelector('[data-variant-dynamic-thumbnails]');
  if (!thumbRoot) return;

  const gallery = document.querySelector('[id^="Slider-Gallery"]');
  if (!gallery) {
    revealVariantThumbnailRail(thumbRoot);
    return;
  }

  const slides = Array.from(gallery.querySelectorAll('.product__media-item:not(.hidden)'));
  const visibleImageSlideIds = slides
    .filter((slide) => !slide.classList.contains('product__media-item--video'))
    .map((slide) => getMediaIdFromTarget(slide.dataset.mediaId))
    .filter(Boolean);

  const thumbMoreSub = window.Resources?.thumbnailMoreSub || 'More';

  thumbRoot.querySelectorAll('[data-thumb-rail="image"]').forEach((li) => {
    const mid = String(li.dataset.mediaNodeId || getMediaIdFromTarget(li.dataset.target) || '');
    const idx = visibleImageSlideIds.indexOf(mid);
    const existingOverlay = li.querySelector('.thumbnail-rail__more-overlay');
    if (existingOverlay) existingOverlay.remove();
    li.classList.remove('thumbnail-rail__item--has-more');

    if (idx === -1) {
      li.classList.add('hidden');
      return;
    }
    if (idx >= 4) {
      li.classList.add('hidden');
      return;
    }
    li.classList.remove('hidden');
    if (idx === 3 && visibleImageSlideIds.length > 4) {
      const n = visibleImageSlideIds.length - 4;
      li.classList.add('thumbnail-rail__item--has-more');
      const overlay = document.createElement('span');
      overlay.className = 'thumbnail-rail__more-overlay thumbnail-rail__more-overlay--tint';
      overlay.setAttribute('aria-hidden', 'true');
      const stack = document.createElement('span');
      stack.className = 'thumbnail-rail__more-stack';
      const countEl = document.createElement('span');
      countEl.className = 'thumbnail-rail__more-count';
      countEl.textContent = `+${n}`;
      const subEl = document.createElement('span');
      subEl.className = 'thumbnail-rail__more-sub';
      subEl.textContent = thumbMoreSub;
      stack.appendChild(countEl);
      stack.appendChild(subEl);
      overlay.appendChild(stack);
      li.appendChild(overlay);
    }
  });

  const videoThumb = thumbRoot.querySelector('[data-thumb-rail="video"]');
  if (videoThumb) {
    const visibleVideoCount = slides.filter((s) => s.classList.contains('product__media-item--video')).length;
    const sub = videoThumb.querySelector('.thumbnail-rail__more-sub');
    const one = thumbRoot.dataset.videoLabelOne;
    const pluralWord = thumbRoot.dataset.videoPluralWord;
    if (visibleVideoCount === 0) {
      videoThumb.classList.add('hidden');
    } else {
      videoThumb.classList.remove('hidden');
      if (sub && one && pluralWord) {
        sub.textContent =
          visibleVideoCount === 1 ? one : `${visibleVideoCount} ${pluralWord}`;
      }
    }
  }

  revealVariantThumbnailRail(thumbRoot);
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent);
    this.setColorVariantLabel();
    this.setPriceLabelAddButton();
    this.updateVariantMetafieldImagesInitial();
    this.updateOptions();
    this.updateMasterId();
    this.addOutOfStockClass();
    this.getStoreAvailability();
    this.updateVariantCopy();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.setColorVariantLabel();
    this.removeColorVariantLabel();
    this.addOutOfStockClass();
    this.updateStickyPrice();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateShippingFeeMessage();
      this.updateItemModel();
      this.updateShippingMessage();
      this.updateWarranties();
      this.updateBogoProducts();
      this.updateVariantMetafieldImages();
      this.updateMaxVariantQuantity();
      this.renderProductInfo();
      this.updateShareUrl();
      this.getStoreAvailability();
      this.updateStickyPrice();
      this.updateVariantCopy();
    }
  }

  updateVariantCopy() {
    const product_details_content = document.getElementById('product-details__content');
    product_details_content.innerHTML = this.additionalVariantData[this.currentVariant.id]?.description;
  }

  updateStickyPrice() {
    const StickyProductPrice = document.getElementById('sticky-bar').querySelector('.price-item--regular');
    if(this.currentVariant) {
      const variantID = this.currentVariant.id
      const variantSelectedPrice = this.additionalVariantData[variantID]?.price;

      const HiddenInput = document.getElementById('Sticky-ATC-hidden-input');
      StickyProductPrice.classList.remove('visibility-hidden');

      StickyProductPrice.textContent = variantSelectedPrice;
      HiddenInput.value = variantID;
    } else {
      StickyProductPrice.classList.add('visibility-hidden');
    }
  }

  getStoreAvailability() {
    const selectedStore = localStorage.getItem("storeSelected");
    const storeId = localStorage.getItem('storeSelectedId');
    const variantID = this.currentVariant.id
    const variantSelectedSku = this.additionalVariantData[variantID]?.sku ?? this.additionalVariantData.productDefaultSku;
    const productAvailabilityAPI = 'https://wcsp-shopify.azurewebsites.net/product-availability';
    const storeAvailabilityWrapper = document.getElementById(`store-availability-wrapper-${this.dataset.section}`);
    const storeAvailabilityMessage = document.getElementById(`store-availability-message-${this.dataset.section}`);
    
    if (storeId && variantSelectedSku) {
      fetch(`${productAvailabilityAPI}?item=${variantSelectedSku}&store=${storeId}`)
      .then((response) => response.json())
      .then((response) => {
        if (response.res[0]?.quantity) {
          storeAvailabilityMessage.innerText = `Available at ${selectedStore}`;
  
        } else {
          storeAvailabilityMessage.innerText = `Call ${selectedStore} for Availability`;
        }

        storeAvailabilityWrapper.classList.remove("hidden");

      });

    } else {

      storeAvailabilityMessage.innerHTML = `<a href="/pages/store-locator" class="store-locator-opener">Favorite a Store to See Pickup Availability</a>`;
      storeAvailabilityWrapper.classList.remove("hidden");
      const storeLocatorIcon = document.querySelector('#store-locator-icon');
      const storeLocatorOpener = document.querySelector('.store-locator-opener');
      storeLocatorOpener.addEventListener('click', e => {
        e.preventDefault();
        storeLocatorIcon.click() 
      });

    }
    
  }


  /**
   * Cheap way to grab a parent media-gallery element from the hierarchy.
   * Probably could be moved to a utility file eventually.
   * @param {*} target - Element
   * @returns null if matching element not found, otherwise the media-gallery.
   */
  getParentMediaGallery(target) {
    let parent = target.parentElement;
    while(parent) {
      if (parent.tagName === 'MEDIA-GALLERY') {
        break;
      }
      parent = parent.parentElement;
    }
    return parent;
  }

  filterVariantImages(imageMegaArray){

    //Get all DOM images by their variant image url dataset
    let allImages = Object.values(document.querySelectorAll("[data-variant-image-url]"));

    const currentVariantImages = allImages.filter(img => imageMegaArray.some( imageMega => imageMega.includes(img.dataset.variantImageUrl) ));

    currentVariantImages.forEach((img, index) => {

      const thumbnailDataTarget = img.dataset.mediaId;
      const thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
      const thumbLi = thumbnails?.querySelector(`[data-target="${thumbnailDataTarget}"]`);

      // Update thumbnail with selection
      thumbLi?.classList.remove("hidden");

      // need to remove 'hidden' from all images for the variant
      // otherwise there are no images to scroll to.
      img.classList.remove("hidden");

      if(index == 0) {
        // This function runs on variant selection, so activate the first image
        img.classList.add("first-img");
        
        img.classList.add("is-active");

        const mediaGallery = this.getParentMediaGallery(img);

        // for some reason this method is not immediately available on initial page load.
        // unsure why but not an issue as we don't need to scroll on load.
        if (mediaGallery?.scrollToActive) {
          // Scroll to first variant image if necessary (also does button active state handling)
          mediaGallery.scrollToActive(img, thumbnailDataTarget);
        } else {
          thumbLi?.querySelector('button')?.setAttribute('aria-current', true);
        }
      }

    })

    // Deactivate all other images (<li> tags containing the image actually) that aren't active for the variant
    const otherVariantImages = allImages.filter(img => !currentVariantImages.includes(img));

    otherVariantImages.forEach(img => {
      const thumbnailDataTarget = img.dataset.mediaId;
      const thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
      const thumbLi = thumbnails?.querySelector(`[data-target="${thumbnailDataTarget}"]`);
      thumbLi?.querySelector('button')?.removeAttribute('aria-current');

      img.classList.remove("is-active");

      // Hide other variant images, but still show videos
      if (!img.classList.contains('product__media-item--video')) {
        img.classList.add("hidden");
        thumbLi?.classList.add("hidden");
      }
    });

    if (imageMegaArray.length <= 6) {
      document.querySelectorAll('.thumbnail-slider .slider-button').forEach(button => {
        button.classList.add("hidden");
      });

    } else {
      document.querySelectorAll('.thumbnail-slider .slider-button').forEach(button => {
        button.classList.remove("hidden");
      });
    }

    syncVariantThumbnailRail();
    this.syncZoomModalVisibility(currentVariantImages, otherVariantImages);
  }

  syncZoomModalVisibility(visibleVariantImages, hiddenVariantImages) {
    const zoomModal = document.querySelector('[data-zoom-modal-container]');
    if (!zoomModal) return;

    const visibleMediaIds = visibleVariantImages.map(img => {
      const fullId = img.dataset.mediaId;
      return fullId.split('-').pop();
    });

    const hiddenMediaIds = hiddenVariantImages.map(img => {
      const fullId = img.dataset.mediaId;
      return fullId.split('-').pop();
    });

    const thumbs = zoomModal.querySelectorAll('[data-zoom-thumbs] [data-media-id]:not([data-zoom-slides="video"])');
    for (const thumb of thumbs) {
      const mediaId = thumb.dataset.mediaId;
      if (visibleMediaIds.includes(mediaId)) {
        thumb.classList.remove('hidden');
        thumb.classList.add('swiper-slide');
      } else if (hiddenMediaIds.includes(mediaId)) {
        thumb.classList.add('hidden');
        thumb.classList.remove('swiper-slide');
      }
    }

    const mainImages = zoomModal.querySelectorAll('[data-zoom-main] [data-media-id]:not([data-zoom-slides="video"])');
    mainImages.forEach(img => {
      const mediaId = img.dataset.mediaId;
      if (visibleMediaIds.includes(mediaId)) {
        img.classList.remove('hidden');
        img.classList.add('swiper-slide');
      } else if (hiddenMediaIds.includes(mediaId)) {
        img.classList.add('hidden');
        img.classList.remove('swiper-slide');
      }
    });

    const zoomHost = zoomModal.closest('product-zoom-modal');
    zoomHost?.refreshAfterVariantMediaSync?.();
  }

  updateVariantMetafieldImages() {

    if(window.Resources.variantImageList != false) {
      
      //Grab what we need from the metafield
      let variantImageArray = window.Resources.variantImageList;

      //Initialize empty array to store all of our images we will need
      let imageMegaArray = [];

      //Check if there is an option1
      if(Array.isArray(variantImageArray) && this.currentVariant.option1 != null) {
        
        //Loop through all of our available image URLs
        variantImageArray.map((variant) => {

          //If there is a URL matching with a variant option1
          if(variant[1].option1 == this.currentVariant.option1) {

            //Check if there is an option2
            if(this.currentVariant.option2 != null) {

              //If there is a URL matching with a variant option2
              if(variant[1].option2 == this.currentVariant.option2) {

                //Check if there is an option3
                if(this.currentVariant.option3 != null) {

                  if(variant[1].option3 == this.currentVariant.option3) {

                    //If the image URL matches all available options, push it to the mega array
                    imageMegaArray.push(variant[0]);
                  }
                }
                else {
                  //If this product has no 3rd variant
                  imageMegaArray.push(variant[0]);
                }
              }
            }
            else {
              //If this image has no 2nd variant
              imageMegaArray.push(variant[0]);
            }
          }
        });
      }

      this.filterVariantImages(imageMegaArray);

    }

  }

  updateVariantMetafieldImagesInitial() {

    if(window.Resources.variantImageList != false) {

      let variantImageArray = window.Resources.variantImageList;

      //Get currently selected/first available variant on load
      let currentVariantSelectedId = document.querySelector("[data-current-variant-selected]").value;
      let variantJSONList = this.getVariantData();
      let findCurrentVariantDetails = variantJSONList.find(c => c.id == currentVariantSelectedId);

      let imageMegaArray = [];

      if(Array.isArray(variantImageArray) && findCurrentVariantDetails.option1 != null) {
          variantImageArray.map((variant) => {
            if(variant[1].option1 == findCurrentVariantDetails.option1) {
              if(findCurrentVariantDetails.option2 != null) {
                if(variant[1].option2 == findCurrentVariantDetails.option2) {
                  if(findCurrentVariantDetails.option3 != null) {
                    if(variant[1].option3 == findCurrentVariantDetails.option3) {
                      imageMegaArray.push(variant[0]);
                    }
                  }
                  else {
                    imageMegaArray.push(variant[0]);
                  }
                }
              }
              else {
                imageMegaArray.push(variant[0]);
              }
            }
          });
      }

      this.filterVariantImages(imageMegaArray);

    }
    
  }

  updateOptions() {
    let swatches = this.querySelectorAll('input');

    if (swatches.length == 0) {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    } else {
      this.inputs = Array.from(swatches).find((radio) => radio.checked).value;
      this.index = Number(document.querySelector('fieldset').getAttribute("node-index"));
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      this.options.splice(this.index, 0, this.inputs)
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  addOutOfStockClass() {
    const variants = this.getVariantData();
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    if (!variants?.length || !fieldsets?.length || !this?.options) return;

    fieldsets.forEach((fieldset, optionIndex) => {
      const radios = Array.from(fieldset.querySelectorAll('input'));

      radios.forEach((radio) => {
        const label = radio.nextElementSibling;

        radio.classList.remove('out-of-stock');
        label?.classList.remove('out-of-stock');

        if (radio.classList.contains('unavailable') || label?.classList.contains('unavailable')) return;

        const potential = this.options.slice();
        potential[optionIndex] = radio.value;

        const match = variants.find(v => v.options.every((o, i) => o === potential[i]));

        if (match && !match.available) {
          radio.classList.add('out-of-stock');
          label?.classList.add('out-of-stock');
        }
      });
    });
  }

  updateMedia() {
    if(window.Resources.variantImageList == false) {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  }

  updateVariantMedia() {
    if(window.Resources.variantImageList == false) {
      let color_inputs = document.querySelectorAll("input[name=Color]");
      let color_dropdown = document.querySelectorAll("select[name='options[Color]']");

      let thumbs = document.querySelectorAll(".thumbnail-list__item img");
      let stackedThumbs = document.querySelectorAll(".product__media-item  img");

      if (color_inputs.length > 0 ) {
        color_inputs.forEach(i => {
          //Check if swatch input or dropdown
          if (i.checked) {
            if(thumbs.length > 0) {
              thumbs.forEach(t => {
                let searchValue = i.value.split(" ").join("-").toLowerCase();
                
                if(t.src.includes(searchValue)) {
                  t.parentElement.parentElement.style.display = "block";
                } else {
                  t.parentElement.parentElement.style.display = "none"
                }
              })
            }

            if (stackedThumbs.length > 0 ) {
              stackedThumbs.forEach(t => {
                let searchValue = i.value.split(" ").join("-").toLowerCase();
                if(t.src.includes(searchValue)) {
                  t.parentElement.parentElement.parentElement.style.display = "block";
                } else {
                  t.parentElement.parentElement.parentElement.style.display = "none"
                }
              })
            }
          }
        })
      } else {
          if (thumbs.length > 0) {
            thumbs.forEach(t => {
              if(color_dropdown[0] != null){
                let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
                if(t.src.includes(searchValue)) {
                  t.parentElement.parentElement.style.display = "block";
                } else {
                  t.parentElement.parentElement.style.display = "none"
                }
              }
            })
          }

          if (stackedThumbs.length > 0 ) {
            stackedThumbs.forEach(t => {
              if(color_dropdown[0] != null){
                let searchValue = color_dropdown[0].value.split(" ")[0].toLowerCase();
                if(t.src.includes(searchValue)) {
                  t.parentElement.parentElement.style.display = "block";
                } else {
                  t.parentElement.parentElement.style.display = "none"
                }
              }
            })
          }
        }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateMaxVariantQuantity() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantID = urlParams.get('variant');
    const variantData = this.additionalVariantData[variantID];
    const quantityInput = document.querySelector('.product input[name="quantity"]');

    if (Number(quantityInput.value) == 0) {
      quantityInput.value = 1;
    }

    //Check first if negative number
    if(Number(variantData.inventory) > 0) {
      if(Number(quantityInput.value) > Number(variantData.inventory)) {
        quantityInput.value = variantData.inventory;
        quantityInput.setAttribute('max', variantData.inventory);
      }
    }
    //If current inventory returns as negative, set the quantity value to 1
    //If its out of stock, the button will be disabled anyway
    //If it's negative but set to Not Track, setting to 1 will ensure they can still buy
    else if (Number(variantData.inventory) < 0) {
      quantityInput.value = 1;
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateShippingFeeMessage() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `shipping-fee-message-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const shippingFeeMessage = document.getElementById(`shipping-fee-message-${this.dataset.section}`);
        if (shippingFeeMessage.innerHTML.trim() != '') {
          shippingFeeMessage.classList.remove('hidden');
        } else {
          shippingFeeMessage.classList.add('hidden');
        }
      });
  }

  updateShippingMessage() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `shipping-message-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const storeAvailabilityMessage = destination.getElementsByClassName("product__store-availability__message")[0]
        if (source && destination) destination.innerHTML = source.innerHTML;
        const shippingMessage = document.getElementById(`shipping-message-${this.dataset.section}`);
        if (storeAvailabilityMessage) {
          shippingMessage.getElementsByClassName("product__store-availability__message")[0].innerHTML = storeAvailabilityMessage.innerHTML;
          const storeAvailabilityWrapper = document.getElementById(`store-availability-wrapper-${this.dataset.section}`);
          storeAvailabilityWrapper.classList.remove("hidden");
          const storeLocatorIcon = document.querySelector('#store-locator-icon');
          const storeLocatorOpener = document.querySelector('.store-locator-opener');
          storeLocatorOpener?.addEventListener('click', e => {
            e.preventDefault();
            storeLocatorIcon.click();
          });
        }
        if (shippingMessage.innerHTML.trim() != '') {
          shippingMessage.classList.remove('hidden');
        } else {
          shippingMessage.classList.add('hidden');
        }
      });
  }

  updateItemModel() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const itemModelId = `#product__item-model__wrapper-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const source = html.querySelector(itemModelId);
        const destinations = document.querySelectorAll(itemModelId);
        destinations.forEach(destination => {

          // const destination = document.getElementById(itemModelId);
          
          if (source && destination) destination.innerHTML = source.innerHTML;
          // const itemModel = document.getElementById(`product__item-model__wrapper-${this.dataset.section}`);
          const itemModel = destination;
          if (itemModel.innerHTML.trim() != '') {
            itemModel.classList.remove('hidden');
          } else {
            itemModel.classList.add('hidden');
          }

      });

      });
  }

  updateWarranties() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const warrantyProductsId = `warranty-products-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(warrantyProductsId);
        const source = html.getElementById(warrantyProductsId);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const warrantyProducts = document.getElementById(`warranty-products-${this.dataset.section}`);
        if (warrantyProducts.innerHTML.trim() != '') {
          warrantyProducts.classList.remove('hidden');
        } else {
          warrantyProducts.classList.add('hidden');
        }
      });
  }

  updateBogoProducts() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const bogoProductsId = `bogo-products-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(bogoProductsId);
      const source = html.getElementById(bogoProductsId);
      if (source && destination) destination.innerHTML = source.innerHTML;
      const bogoProducts = document.getElementById(`bogo-products-${this.dataset.section}`);
      if (bogoProducts.innerHTML.trim() != '') {
        bogoProducts.classList.remove('hidden');
      } else {
        bogoProducts.classList.add('hidden');
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

renderProductInfo() {

  const isAvailable = Boolean(this.currentVariant?.available);
  this.toggleAddButton(!isAvailable, isAvailable ? null : window.variantStrings.soldOut);

  this._abort?.abort();
  const controller = new AbortController();
  this._abort = controller;

  const priceSectionId = this.dataset.section;
  const productDetailsEl = document.querySelector('#product-details');
  const detailsSectionId = productDetailsEl?.dataset.section;
  const sectionsParam = [priceSectionId, detailsSectionId].filter(Boolean).join(',');
  if (!sectionsParam) return;

  const base =
    this.dataset.url ||
    document.querySelector('link[rel=canonical]')?.getAttribute('href') ||
    window.location.pathname;

  const url = new URL(base, window.location.origin);
  url.searchParams.set('sections', sectionsParam);
  url.searchParams.set('variant', String(this.currentVariant.id));

  const requestedVariantId = this.currentVariant.id;
  const parser = this._parser ?? (this._parser = new DOMParser());

  this.closest('section')?.classList.add('is-loading');

  fetch(url.toString(), { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' }})
    .then(r => r.json())
    .then(json => {
      if (this.currentVariant?.id !== requestedVariantId) return;

      requestAnimationFrame(() => {
        if (json[priceSectionId]) {
          const doc = parser.parseFromString(json[priceSectionId], 'text/html');
          const priceSelector = `#price-${priceSectionId}`;
          const src = doc.querySelector(priceSelector);

          if (src) {
            const dests = Array.from(document.querySelectorAll(priceSelector));
            dests.forEach(d => { d.innerHTML = src.innerHTML; d.classList.remove('visibility-hidden'); });

            const displayedPrice = dests[0]?.querySelector('.price-item')?.textContent?.trim() ?? '';
            if (displayedPrice) this.updateAddButtonPriceSuffix(displayedPrice);
          }
        }

        if (detailsSectionId && json[detailsSectionId] && productDetailsEl) {
          const doc = parser.parseFromString(json[detailsSectionId], 'text/html');
          const srcDocs = doc.querySelector('.product-details__document-list');
          const dstDocs = productDetailsEl.querySelector('.product-details__document-list');
          if (srcDocs && dstDocs) dstDocs.innerHTML = srcDocs.innerHTML;
        }
      });
    })
    .catch(err => { if (err.name !== 'AbortError') console.error(err); })
    .finally(() => this.closest('section')?.classList.remove('is-loading'));
}

toggleAddButton(disable = true, text = null, modifyClass = true) {
  const formIds = [`product-form-${this.dataset.section}`, 'sticky-bar'];

  formIds
    .map(id => document.getElementById(id))
    .filter(Boolean)
    .forEach(form => {
      const btn = form.querySelector('[name="add"]');
      const span = btn?.querySelector('span');
      if (!btn || !span) return;

      if (btn.disabled !== Boolean(disable)) btn.disabled = Boolean(disable);

      if (disable) {
        if (text && span.textContent !== text) span.textContent = text;
      } else {
        const base = window.variantStrings.addToCart;
        if (span.textContent !== base) span.textContent = base;
      }

      if (modifyClass) {
       return;
      }
    });
  }

updateAddButtonPriceSuffix(priceText) {
  if (!priceText) return;

  const hidePrice = document.querySelector('[data-hide-price]')?.dataset.hidePrice === 'true';
  if (hidePrice) return;

  const suffix = `${window.variantStrings.addToCart} - ${priceText}`;
  const formIds = [`product-form-${this.dataset.section}`, 'sticky-bar'];

  formIds
    .map(id => document.getElementById(id))
    .filter(Boolean)
    .forEach(form => {
      const btn = form.querySelector('[name="add"]');
      const span = btn?.querySelector('span');
      if (!btn || !span || btn.disabled) return; 
      if (span.textContent !== suffix) span.textContent = suffix;
    });
  }

setPriceLabelAddButton() {
  const formIds = [`product-form-${this.dataset.section}`, 'sticky-bar'];
  
  formIds.forEach(formId => {
      const form = document.getElementById(formId);
      if (!form) return;

      const button = form.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      let price = document.querySelector(".price-item").innerText;
      let hidePrice = document.querySelector("[data-hide-price]").dataset.hidePrice;

      if (button.hasAttribute('disabled')) {
          addButtonText.textContent = window.variantStrings.soldOut;
      } else {
          if (hidePrice != "true") {
              addButtonText.textContent = window.variantStrings.addToCart + " - " + price;
          }
      }
  });
}


  setUnavailable() {
    // Array of form IDs
    const formIds = [`product-form-${this.dataset.section}`, 'sticky-bar'];
    
    formIds.forEach(formId => {
        const form = document.getElementById(formId);
        if (!form) return;

        const addButton = form.querySelector('[name="add"]');
        const addButtonText = form.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        
        if (!addButton) return;
        
        addButtonText.textContent = window.variantStrings.unavailable;
        
        if (price) price.classList.add('visibility-hidden');
    });
}


  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  setColorVariantLabel() {
    let colorLabel = document.querySelector(".color_label");
    let colorInputs = document.querySelectorAll("input[name=Color]")

    for (var i = 0; i < colorInputs.length; i++) {
      if (colorInputs[i].checked) {
      colorLabel.innerHTML += "<span class='color__variant'>: " + colorInputs[i].value + "</span>"
      }
    }
  }

  removeColorVariantLabel() {
    let colorVariant = document.querySelector(".color__variant");
      if (colorVariant !== 'undefined' && colorVariant !== null) {
      colorVariant.remove()
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // batch onVariantChange() so we never queue multiple calls in the same frame
    this._changeScheduled = false;
  }

  // Consolidated scheduler to avoid duplicate rAF calls and race conditions
  _scheduleVariantChange() {
    if (this._changeScheduled) return;
    this._changeScheduled = true;
    requestAnimationFrame(() => {
      this._changeScheduled = false;
      this.onVariantChange();
    });
  }

  recalculateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.recalculateOptions();

    const lastFieldset = fieldsets[fieldsets.length - 1];
    const variants = this.getVariantData();
    if (!lastFieldset) return;

    const lastOptionPosition = Number(lastFieldset.dataset.optionSet);
    const lastRadios = lastFieldset.querySelectorAll('input');

    // Check if a combination exists (ignoring stock availability)
    const hasCombination = (options) => {
      return !!variants.find(v => v.options.every((o, i) => o === options[i]));
    };

    // Check if the last option value is reachable (exists in any variant)
    const isLastOptionReachable = (lastOption) => {
      const potential = this.options.slice();
      potential[lastOptionPosition] = lastOption;
      return hasCombination(potential);
    };

    // Step 1: Mark last-level radios as unavailable if combination doesn't exist
    lastRadios.forEach(lastRadio => {
      if (isLastOptionReachable(lastRadio.value)) {
        lastRadio.classList.remove('unavailable');
        lastRadio.nextElementSibling?.classList.remove('unavailable');
      } else {
        lastRadio.classList.add('unavailable');
        lastRadio.nextElementSibling?.classList.add('unavailable');
        // Ensure out-of-stock class is cleared when unavailable
        lastRadio.classList.remove('out-of-stock');
        lastRadio.nextElementSibling?.classList.remove('out-of-stock');
      }
    });

    // Step 2: If there is a previous option level, mark options as unavailable when no valid combination exists with any last-level value
    if (fieldsets.length > 1) {
      const previousLevelRadios = fieldsets[fieldsets.length - 2].querySelectorAll('input');
      previousLevelRadios.forEach(previousRadio => {
        const potential = this.options.slice();
        potential[fieldsets.length - 2] = previousRadio.value;

        const allEndValuesImpossible = Array.from(lastRadios).every(lastRadio => {
          potential[fieldsets.length - 1] = lastRadio.value;
          return !hasCombination(potential);
        });

        if (allEndValuesImpossible) {
          previousRadio.classList.add('unavailable');
          previousRadio.nextElementSibling?.classList.add('unavailable');
          previousRadio.classList.remove('out-of-stock');
          previousRadio.nextElementSibling?.classList.remove('out-of-stock');
        } else {
          previousRadio.classList.remove('unavailable');
          previousRadio.nextElementSibling?.classList.remove('unavailable');
        }
      });
    }

    // Step 3: If the selected last-level option is not reachable, select the first reachable option
    const chosenStillReachable = isLastOptionReachable(this.options[lastOptionPosition]);
    if (!chosenStillReachable) {
      let fallback = null;
      lastRadios.forEach(r => {
        if (!r.classList.contains('unavailable') && !fallback) fallback = r;
      });
      if (fallback && !fallback.checked) {
        this.options[lastOptionPosition] = fallback.value;
        fallback.checked = true;
        // Consolidated schedule (no duplicate rAFs)
        this._scheduleVariantChange();
      }
    }

    // Step 4: For each option level, if the selected value is unavailable, select the first available option
    fieldsets.forEach(fieldset => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      const checked = inputs.find(r => r.checked);
      if (checked?.classList.contains('unavailable')) {
        const firstAvailable = inputs.find(r => !r.classList.contains('unavailable'));
        if (firstAvailable && !firstAvailable.checked) {
          firstAvailable.checked = true;
          this._scheduleVariantChange();
        }
      }
    });

    this.recalculateOptions();

    // Step 5: Run the last-level availability check again to ensure updated state
    lastRadios.forEach(lastRadio => {
      if (isLastOptionReachable(lastRadio.value)) {
        lastRadio.classList.remove('unavailable');
        lastRadio.nextElementSibling?.classList.remove('unavailable');
      } else {
        lastRadio.classList.add('unavailable');
        lastRadio.nextElementSibling?.classList.add('unavailable');
        lastRadio.classList.remove('out-of-stock');
        lastRadio.nextElementSibling?.classList.remove('out-of-stock');
      }
    });

    // Step 6: If only one last-level option is available, auto-select it
    const lastAvailableOptions = Array.from(lastRadios).filter(r => !r.classList.contains('unavailable'));
    if (lastAvailableOptions.length === 1) {
      const onlyOne = lastAvailableOptions[0];
      if (!onlyOne.checked) {
        onlyOne.checked = true;
        this.options[lastOptionPosition] = onlyOne.value;
        this._scheduleVariantChange();
      }
    }
  }
}


customElements.define('variant-radios', VariantRadios);

// TODO Move this to quantityInput
/** Setting Quantity input to maximum product quantity on keyboard input **/
const quantityInput = document.querySelector('.product input[name="quantity"]');
if (quantityInput) {
  quantityInput.addEventListener('change', function() {
  let qtyMax = quantityInput.getAttribute("max");
  if (qtyMax != null && Number(quantityInput.value) > qtyMax) {
    quantityInput.value = (qtyMax != 0) ? qtyMax : 1;
  }
})
};

function onNavLink(e) {
  const isTouch = e.type === 'touchstart';
  const isHoveredOrTouched = isTouch ? true : e.target.matches(':hover');
    if (isHoveredOrTouched) {
      this.parentElement.parentElement.querySelectorAll('.header__submenu-has-children, .no-grandchildren').forEach((headerSubmenu) => {
        headerSubmenu.classList.remove('is-open');
        headerSubmenu.setAttribute('aria-expanded', 'false');
      });
      this.classList.add('is-open');
      this.setAttribute('aria-expanded', 'true')
    } else if(e.key == 'Enter' || e.key == ' ') {
      this.parentElement.parentElement.querySelectorAll('.header__submenu-has-children, .no-grandchildren').forEach((headerSubmenu) => {
          headerSubmenu.classList.remove('is-open');
          headerSubmenu.setAttribute('aria-expanded', 'false') ;
      });
      if(this.classList.contains('is-open')) {
        this.classList.remove('is-open');
        this.setAttribute('aria-expanded', 'false');
      } else {
        this.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    }
};

document.addEventListener("DOMContentLoaded", function() {
  var windowWidth = window.innerWidth;

  if(windowWidth > 990) {
    const desktopNavLinks = document.querySelectorAll('.header__submenu--left-rail.header__link-lists .header__submenu-has-children');
    const desktopNavLinksChildrenless = document.querySelectorAll('.header__submenu--left-rail.header__link-lists .no-grandchildren');
    const allDesktopNavLinksNoChild = document.querySelectorAll('.header__submenu--left-rail.header__link-lists a');
    desktopNavLinks.forEach(desktopNavLink => {
      desktopNavLink.addEventListener('mouseover', onNavLink)
      desktopNavLink.addEventListener('touchstart', onNavLink)
      desktopNavLink.addEventListener('keypress', onNavLink)
    });
    desktopNavLinksChildrenless.forEach(desktopNavLink => desktopNavLink.addEventListener('mouseover', (e) => {
      if (e.target.matches(":hover")) {
        e.target.parentElement.parentElement.querySelectorAll('.is-open').forEach((anyLink) => anyLink.classList.remove('is-open'));
        e.target.classList.add('is-open');            
      }            
    }));
    allDesktopNavLinksNoChild.forEach(desktopNavLink => desktopNavLink.addEventListener('touchstart', (e) => {
      e.preventDefault();
      const isTouch = e.type === 'touchstart';
      if (isTouch) {
        e.target.click();          
      }            
    }));
  }
});

/** Adding fixed autocomplete component on mobile **/
document.addEventListener("DOMContentLoaded", () => { 
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const searchInput = document.querySelector('.ss__search-mobile');

  const bodySetOverflowHidden = () => { 
    body.classList.add('overflow-hidden');
    body.style.height = '100vh';

    html.classList.add('overflow-hidden');
    html.style.height = '100vh';
  };

  const bodyUnsetOverflowHidden = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    const storeDetailsDrawer = document.querySelector('store-details-drawer');
    const accountMenuDrawer = document.querySelector('account-menu-drawer');

    if (!cartDrawer.classList.contains('active') && !storeDetailsDrawer.classList.contains('active') && !accountMenuDrawer.classList.contains('active')) { 
      body.classList.remove('overflow-hidden');
      body.style.height = '';
  
      html.classList.remove('overflow-hidden');
      html.style.height = '';
    }
  };

  /** Hide body scroll when search is open **/
  document.addEventListener('click', () => {   
    if ( document.activeElement == searchInput ) {
      bodySetOverflowHidden();
    } else {
      bodyUnsetOverflowHidden();
    } 
  });

  /** Hide body scroll when search is open through tab focus **/
  searchInput.addEventListener('focus', () => {   
    bodySetOverflowHidden();
  });

  /** Toggle body scroll hidden depending on screen size **/
  window.addEventListener('resize', () => { 
    const autoCompleteResults = document.querySelector('.ss__autocomplete');
    if (autoCompleteResults) {
      if (window.innerWidth < 990) {
        bodySetOverflowHidden();
      } else{
        bodyUnsetOverflowHidden();
      }
    }
  });

   /* Close button behavior */
   const searchInputs = document.querySelectorAll('.search .search__input');
   const searchButtons = document.querySelectorAll('.search .search__button');
   const closeButtons = document.querySelectorAll('.search .close__button');
 
   searchInputs.forEach( searchInput => {
     
       closeButtons.forEach((closeButton) =>{ 
         
         closeButton.addEventListener("click", () => {
           searchInput.value = "";
           closeButton.style.display = 'none';
         });
     });
     searchInput.addEventListener("focus", () => {
       closeButtons.forEach((closeButton) =>{ 
           closeButton.style.display = 'block';
       });
     });
     searchInput.addEventListener("blur", (e) => {
       if(e.relatedTarget?.classList?.contains("close__button")){
         searchInput.value = "";
       }
       if(searchInput.value == "") {
         closeButtons.forEach(closeButton => closeButton.style.display = 'none');
       }
       
     });
   });

});

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// Update the value when the viewport changes
window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// Additionally, handle orientation change on mobile devices
window.addEventListener('orientationchange', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});


document.addEventListener('DOMContentLoaded', () => {
  const viewMoreButton = document.querySelector('.view-more-button');
  if (viewMoreButton) {
    viewMoreButton.addEventListener('click', event => {
      const target = document.querySelector(viewMoreButton.getAttribute('href'));
      if (target) {
        event.preventDefault();
        const offset = -60;
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: targetPosition + offset,
          behavior: 'smooth'
        });

        scrollToWithCallback(targetPosition + offset, () => {
          focusOnFirstElement(target)
        });
      }
    });
  }
});

const focusOnFirstElement = (container) => {
  if(container) {
    const focusableElements = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary'
    )

    if(focusableElements.length) {
      const [firstFocusElement] = focusableElements
      firstFocusElement.focus()
    }
  }
}

const scrollToWithCallback = (targetY, callback) => {
  window.scrollTo({
    top: targetY,
    behavior: 'smooth'
  });

  const checkScrollEnd = () => {
    const currentY = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(currentY - targetY) < 1 || currentY === targetY) {
      window.removeEventListener('scroll', checkScrollEnd);
      if (callback && typeof callback === 'function') {
        callback();
      }
    }
  };

  window.addEventListener('scroll', checkScrollEnd);
  checkScrollEnd();
}

const announce = (message) => {
  const el = document.getElementById('sr-announcer');
  if (!el) return;

  // Clear first so repeated messages still announce
  el.textContent = '';

  requestAnimationFrame(() => {
    el.textContent = message;
  });
}

const announceInit = () => {
  const el = document.getElementById('sr-announcer');
  if (!el) return;

  el.textContent = '';
}

document.addEventListener('DOMContentLoaded', () => {
  syncVariantThumbnailRail();
});
